function getComputedTheme() {
  return globalThis.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

function setTheme(theme: string) {
  // Inpired by: https://paco.me/writing/disable-theme-transitions
  // Disable all transitions to prevent flicker when changing theme
  const themeStyleTag = document.createElement('style');
  themeStyleTag.append(document.createTextNode('* {transition: none !important;}'));
  document.head.append(themeStyleTag);

  // Update theme
  const html = document.querySelector('html');
  if (html) html.dataset.theme = theme === 'system' ? getComputedTheme() : theme;

  // Calling getComputedStyle triggers a redraw, but only when accessing a property
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- see comment above
  const _ = globalThis.getComputedStyle(themeStyleTag).opacity;

  // Clean-up the style tag
  themeStyleTag.remove();
}

export {setTheme};
